import styled from 'styled-components';
import { RemoveUndefined, Sanity } from 'src/types';
import { SanityBadgeProps } from './types';

export const SanityBadge = styled.span<RemoveUndefined<{$tone: SanityBadgeProps['tone']; $outline: SanityBadgeProps['outline']}>>`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  height: 2em;
  box-sizing: border-box;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-family: 'akzidenz-grotesk', helvetica, 'helvetica neue', arial, sans-serif;
  font-size: 0.875rem;
  font-weight: bold;
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  background-color: ${({ $tone }) => Sanity.Types.SanityToneColors[$tone]};
  /* color: ${({ $tone }) => Sanity.Types.SanityToneColors[$tone]}; */
  color: #000;
  border: 1px solid ${({ $tone }) => Sanity.Types.SanityToneColors[$tone]};
  vertical-align: middle;
  user-select: none;
  ${({ $outline, $tone }) => $outline && `
    background-color: transparent;
    color: ${Sanity.Types.SanityToneColors[$tone]};
  `}
`;

export const BadgeIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1em;
  height: 1em;
  vertical-align: middle;
  flex-shrink: 0;
  line-height: 1;
`;

export const BadgeText = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  flex-shrink: 0;
  line-height: 1;
`;
